import { render, staticRenderFns } from "./ChallengeHeader.vue?vue&type=template&id=1b3599ac&scoped=true&"
import script from "./ChallengeHeader.vue?vue&type=script&lang=js&"
export * from "./ChallengeHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHeader.vue?vue&type=style&index=0&id=1b3599ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3599ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
